import { AnimatePresence, motion } from 'motion/react';
import { useTranslation } from 'react-i18next';
import { twJoin } from 'tailwind-merge';
import MainButton from '@/components/ui/custom/buttons/MainButton';
import { fadeInOut } from '@/utils/animations/commom';

type Props = {
  render: boolean;
  onUpdate: () => void;
};

export const UpdateNotification = ({ render, onUpdate }: Props) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'updateNotification',
  });

  return (
    <AnimatePresence>
      {render && (
        <motion.div
          {...fadeInOut}
          className={twJoin(
            'fixed bottom-0 left-0 right-0 z-50',
            'bg-primary-content text-center p-4 shadow-default',
            'flex items-center gap-2.5 justify-center',
          )}
        >
          {t('message')}
          <MainButton text={t('update')} onClick={() => onUpdate()} />
        </motion.div>
      )}
    </AnimatePresence>
  );
};
